module.exports = __webpack_public_path__ + "img/sticker-mule.88ced335.svg";